import React, { useRef, useEffect } from "react";
import classes from "./Navigation.module.css";
import { NavLink } from "react-router-dom";
import { gsap } from "gsap";
import wordmark from "../../../assets/wordmarks/Dickinson_WHITE.png";

const Navigation = (props) => {
  const navRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline();

    timeline.to(navRef.current, {
      opacity: 1,
      duration: 0.2,
      ease: "sine.out",
    });
  });

  return (
    <div ref={navRef} className={classes.Navigation}>
      <div className={classes.Logo}>
        <a target='_blank' rel="noopener noreferrer" href="https://www.dickinson.edu">
          <img src={wordmark} alt="Dickinson" />
        </a>
      </div>
      <nav className={classes.NavList}>
        <ul>
          <li>
            <NavLink
              exact
              activeClassName={classes.active}
              onClick={props.clicked}
              to="/"
            >
              Welcome
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              exact
              onClick={props.clicked}
              to="/identity"
            >
              Identity
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              exact
              onClick={props.clicked}
              to="/academic-endeavors"
            >
              Academic Endeavors
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              exact
              onClick={props.clicked}
              to="/alumni-success"
            >
              Alumni Success
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              exact
              onClick={props.clicked}
              to="/community"
            >
              Community
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              exact
              onClick={props.clicked}
              to="/global-opportunities"
            >
              Global Opportunities
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              exact
              onClick={props.clicked}
              to="/sustainable-leadership"
            >
              Sustainable Leadership
            </NavLink>
          </li>
          <li>
            <NavLink
              activeClassName={classes.active}
              exact
              onClick={props.clicked}
              to="/student-life"
            >
              Student Life
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navigation;
